<drawer [title]="'Entries filters'"
        [contextLabel]="entriesContextLabel"
        [contextVariant]="'neutral'"
        [isClosed]="false" (saveEvent)="save();" (closeEvent)="close();" class="text-left">
    <!--
    <div class="row drawer-content-header">
        <div class="col">
            <button (click)="save();" class="align-self-center btn btn-md btn-rounded btn-success mr-2 text-uppercase">
                {{ 'Save' | translate }}
            </button>
            <button (click)="close()" type="button" class="btn btn-slightly-darker btn-rounded btn-md text-uppercase mr-2 align-self-center">
                {{ 'Cancel' | translate }}
            </button>
        </div>
    </div>
    -->
    <div class="row drawer-content drawer-direct-content">
        <determinant-builder-new *ngIf="serviceId" [serviceId]="serviceId"
                        [jsonString]="tempFilters"
                        (onCancel)="close()"
                        [showSaveCancelRow]=false
                        (onChange)="updateDeterminantFilter($event)"
                        class="col-12 card m-0 p-0 h-100">
                    </determinant-builder-new>
    </div>
</drawer>

<drawer [title]="(store.state.common.determinantSection.determinant != null && store.state.common.determinantSection.determinant.hasOwnProperty('id')) ? 'Edit Determinant' : 'Add Determinant'"
    [contextLabel]="editDeterminantContextLabel"
    [contextVariant]="'neutral'"
    *ngIf="store.state.common.determinantSection.topLayer === 'edit'" [isClosed]="false" (closeEvent)="closeEdit();" class="text-left">
    <div class="row drawer-content">
        <div class="drawer-content drawer-direct-content">
            <determinant-new
                    class="col-12 card mb-0 h-100"
                    [serviceId]="serviceId"
                    [hideHeader]="true"
                    [stickyScrolling]="true"
                    [determinant]="store.state.common.determinantSection.determinant"
                    (formSubmit)="closeEdit()"
                    (editCancel)="closeEdit()"></determinant-new>
        </div>
    </div>
</drawer>
